import { Dropdown, FC } from 'external/react'
import { IconName } from 'external/fortawesome'

import MenuItem from './MenuItem'

type MenuItemTuple = [string, IconName, string]

type MenuProps = {
    label?: string,
    items: Array<MenuItemTuple>
}

const Menu: FC<MenuProps> = (props) => {
    const {label = 'Menú', items} = props
    return (
        <li className='nav-item me-4'>
            <Dropdown>
                <Dropdown.Toggle variant='light' id='dropdown-basic'> {label} </Dropdown.Toggle>
                <Dropdown.Menu>
                    {items.map(([to, icon, label], index) => (<MenuItem key={index} to={to} icon={icon} label={label} />))}
                </Dropdown.Menu>
            </Dropdown>
        </li>
    )
}

export {Menu as default}